import { axiosInstance } from './axiosInstance';

export const getScoresTimeLine = (user) => {
    return axiosInstance.get(`stats/kss_scores_timeline`, {
        params: {
            user: user,
            team_id: localStorage.getItem('team-id'),
        },
    });

}

export const getTrackerStats = (period, user, team) =>
    axiosInstance({
        method: 'get',
        url: `stats/get_tracker_stat_period`,
        headers: { 'Content-Type': 'application/json' },
        params: {
            user: user || localStorage.getItem('user-id-for-admin-panel') || localStorage.getItem('user-id'),
            team: team || localStorage.getItem('team-id'),
            time_type: period,
        },
    });

export const getUserSessionStats = (period, user, team) =>
    axiosInstance({
        method: 'get',
        url: `stats/user_session_stat`,
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            user: user || localStorage.getItem('user-id-for-admin-panel') || localStorage.getItem('user-id'),
            team: team || localStorage.getItem('team-id'),
            period: period,
        },
    });

export const getTeamSessionStats = (period = 'week', user, team) =>
    axiosInstance({
        method: 'get',
        url: `stats/team_session_stat`,
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            id: team || localStorage.getItem('team-id'),
            user: user || localStorage.getItem('user-id-for-admin-panel'),
        },
    });

export const createRate = (cardData) =>
    axiosInstance.post(`score/create_by_user/`, {
        result: cardData.score.result,
        user: cardData.user,
        team: cardData.team,
        behavior: cardData.behavior,
        belong: cardData.belong,
        session_team: localStorage.getItem('session-team'),
    });

export const updateRate = (cardData, sessionId) =>
    axiosInstance.put(`score/${cardData.score.id}/`, {
        result: cardData.score.result,
        user: cardData.user,
        team: cardData.team,
        behavior: cardData.behavior,
        belong: cardData.belong,
        session_team: sessionId,
    });

export const getWeekDayStats = (user, team) =>
    axiosInstance({
        method: 'get',
        url: `stats/user_kss_stat`,
        headers: { 'Content-Type': 'application/json' },
        params: {
            user: user || localStorage.getItem('user-id-for-admin-panel') || localStorage.getItem('user-id'),
            team: team || localStorage.getItem('team-id'),
        },
    });

export const getMyProgress = (userId) => {
    const options = { params: {} };
    const teamId = localStorage.getItem('team-id');

    if (userId && typeof userId === 'number') {
        options.params.user_id = userId;

    } else {
        options.params.user_id = localStorage.getItem('user-id-for-admin-panel') || localStorage.getItem('user-id');
    }

    if (teamId) {
        options.params.team_id = teamId;
    }

    return axiosInstance.get(`stats/my_progress`, options);
};

export const getMyWeekProgress = (userId) => {
    return axiosInstance.get('stats/user_week_progress', {
        params: {
            user: userId || localStorage.getItem('user-id-for-admin-panel') || localStorage.getItem('user-id'),
        }
    });
};
